import type { ComponentChildren } from "preact";

export function Modal({
  title,
  onClose,
  children,
  width = 480,
}: {
  title: string;
  onClose: () => void;
  children: ComponentChildren;
  width?: number;
}) {
  return (
    <div class="overlay" onClick={onClose}>
      <div
        class="modal"
        style={{ maxWidth: `${width}px` }}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div class="modal__header">
          <h2>{title}</h2>
          <button type="button" class="icon-button" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div class="modal__body">{children}</div>
      </div>
    </div>
  );
}

export function Drawer({
  title,
  onClose,
  children,
  actions,
}: {
  title: ComponentChildren;
  onClose: () => void;
  children: ComponentChildren;
  actions?: ComponentChildren;
}) {
  return (
    <div class="overlay" onClick={onClose}>
      <aside class="drawer" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div class="drawer__header">
          <div class="drawer__title">{title}</div>
          <div class="row">
            {actions}
            <button type="button" class="icon-button" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>
        </div>
        <div class="drawer__body">{children}</div>
      </aside>
    </div>
  );
}
